import { Container } from "react-bootstrap";
import Button from "./Button";

const ExploreJumbotron = () => {
  return (
    <Container className="p-0">
      <div className="bg-light p-5 text-dark shadow-lg d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div className="mb-3 mb-md-0">
          <h1 className="display-5 fw-bold">Looking for a dream home?</h1>
          <p className="lead">We can help you realize your dream of a new home</p>
        </div>
        <Button text="EXPLORE PROPERTIES" className="text-muted" href="/properties" />
      </div>
    </Container>
  );
};

export default ExploreJumbotron;